import FunctionalButton from "components/layout/FunctionalButton";

import SkeletonImage from "components/layout/loading/SkeletonImage";

import { ReactComponent as ClockIcon } from "assets/svgs/Clock.svg";
import { ReactComponent as DeleteIcon } from "assets/svgs/navigation/mission/CreateMissionDelete.svg";
import { ReactComponent as LocationIcon } from "assets/svgs/navigation/Location.svg";

const MapCard = ({
    map = "",
    floor = "",
    location = "",
    lastUpdated = "",
    graph,
    onCardClick = () => {},
    onDelete,
}) => {
    return (
        <div
            className="flex h-[17.5rem] min-w-[17.5rem] cursor-pointer flex-col items-center justify-start rounded-r5 bg-black90 transition-all hover:bg-black70"
            onClick={onCardClick}
        >
            <div className="flex w-full flex-col items-center justify-start space-y-2 p-4">
                <div className="flex w-full  items-center justify-between">
                    <p className="text-h5">
                        {map} {floor && `(${floor})`}
                    </p>
                    {onDelete && (
                        <FunctionalButton
                            icon={<DeleteIcon />}
                            className="h-5 w-5"
                            onClick={(event) => {
                                event.stopPropagation();
                                onDelete();
                            }}
                        />
                    )}
                </div>
                <div className="flex w-full  items-center justify-between">
                    <div className="flex  items-center space-x-2">
                        <LocationIcon />
                        <p className="text-h5">{location}</p>
                    </div>
                    {lastUpdated && (
                        <div className="flex  items-center space-x-2">
                            <ClockIcon />
                            <p className="text-h5">{lastUpdated && `Updated ${lastUpdated}`}</p>
                        </div>
                    )}
                </div>
            </div>
            {graph ? (
                <img
                    className="h-full max-h-[calc(17.5rem-4.875rem)] w-full rounded-b-r5"
                    src={graph}
                    alt="Map"
                />
            ) : (
                <SkeletonImage />
            )}
        </div>
    );
};

export default MapCard;
